import { Button, FlexRow, useTranslate } from '@synqo/frontend-component-library';
import classes from './ContainersAtSite.module.css';

interface OrderLinkProps {
    orderId: string | undefined;
    number: string;
    accent?: boolean;
    /** Opens the order without leaving the page. */
    onOpen: (orderId: string) => void;
}

// @ai-generated 2026-10-13T14:40:42+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5
export function OrderLink({ orderId, number, accent = false, onOpen }: OrderLinkProps) {
    const i18n = useTranslate('');
    const label = `${i18n('Auftrag')} ${number}`;

    if (!orderId) {
        return <FlexRow className={classes.muted}>{label}</FlexRow>;
    }

    return (
        <Button
            appearance="transparent"
            size="xxs"
            className={accent ? classes.accentLink : classes.mutedLink}
            onClick={() => onOpen(orderId)}
        >
            {label}
        </Button>
    );
}
